module.exports = __webpack_public_path__ + "static/img/profile-icon05.ada9a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon05.png
// module id = 2953
// module chunks = 1